<template>
  <div class="wscn-http404-container">预售商品展位</div>
</template>

<script>
export default {
  name: 'AuthList',
}
</script>